export default __webpack_public_path__ + "static/media/profile.ce29de99.jpg";